import React, {useState} from 'react';
import {Heading, VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../../../components/buttons';
import {SpinnerModal} from '../../../../../components/modals';
import InternalTemplate from '../../../../../components/templates/internal';
import {StackParamList} from '../../../../../navigators';
import {useSalesmanContext} from '../../../../../context/salesman';
import useToast from '../../../../../hooks';
import {message} from '../../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'ScheduleCodeScanner'
>;

interface IQrData {
  client?: string;
  code?: string;
}

const ScheduleCodeScanner = ({navigation}: ScreenProps) => {
  const {sendAppointConfirmation} = useSalesmanContext();
  const [isLoading, setIsLoading] = useState(false);
  const [qrValue, setQrValue] = useState<IQrData | null>(null);
  const {showServerError} = useToast();

  const handleGoBack = () => {
    navigation.goBack();
  };

  const showScanner = () => {
    return qrValue == null;
  };

  const handleScanQr = () => {
    setQrValue(null);
  };

  const handleSendConfirmation = async () => {
    if (qrValue && qrValue.code) {
      setIsLoading(true);
      const success = await sendAppointConfirmation(qrValue?.code);
      try {
        if (success) {
          navigation.navigate('SalesmanScheduleSuccess');
        } else {
          showServerError();
        }
      } catch (ex) {
        showServerError();
      }

      setIsLoading(false);
    }
  };

  return (
    <InternalTemplate
      title={'screen-qr-code-scanner-title'}
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back-confirm',
        usage: 'internal',
      }}>
      <SpinnerModal show={isLoading} />
      <>
        {showScanner() && (
          <Heading
            textAlign={'center'}
            marginBottom={5}
            color={'#0088FF'}
            fontSize={20}>
            {message('schedule-code-scanner-title')}
          </Heading>
        )}
      </>
      <>
        {!showScanner() && (
          <Heading
            textAlign={'center'}
            marginBottom={5}
            color={'#0088FF'}
            fontSize={20}>
            {message('schedule-code-scanner-title-result')}
          </Heading>
        )}
      </>

      <>
        {showScanner() && (
          <VStack justifyContent={'center'}>
            <Heading
              size="sm"
              fontWeight="medium"
              color="#4C4C4C"
              marginTop={5}
              marginBottom={5}>
              {message('schedule-code-scanner-summary')}
            </Heading>
            <SecondaryButton label="Cancelar" onPress={handleGoBack} />
          </VStack>
        )}
      </>

      <>
        {!showScanner() && (
          <>
            <Heading
              textAlign={'center'}
              marginBottom={10}
              color={'#184062'}
              fontSize={20}
              marginTop={5}>
              {qrValue?.client}
            </Heading>
            <VStack marginX={5} space={5}>
              <PrimaryButton
                label={message('schedule-code-scanner-confirm-button')}
                onPress={handleSendConfirmation}
              />
              <SecondaryButton
                label={message('schedule-code-scanner-retry-button')}
                onPress={handleScanQr}
              />
            </VStack>
          </>
        )}
      </>
    </InternalTemplate>
  );
};
export default ScheduleCodeScanner;
